module.exports = __webpack_public_path__ + "images/blueWhale.bc52443.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/hoverProducts/blueWhale.png
// module id = 0yHz
// module chunks = 19